<template>
  <div>
    <carouselSection />
    <main id="main" style="padding-top:20px">
      <contentSection data-aos="fade-left" />
      <latestWeeks data-aos="fade-up" />
      <searchSection data-aos="fade-down" />
    </main>
  </div>
</template>

<script>
/* eslint-disable */
import carouselSection from "./carouselSection";
import contentSection from "./contentSection";
import latestWeeks from "./latestWeeks";
import searchSection from "./searchSection";
import AOS from "aos";
import "aos/dist/aos.css";
export default {
  created() {
    AOS.init();
  },
  components: {
    carouselSection,
    contentSection,
    latestWeeks,
    searchSection
  }
};
</script>

<style lang="scss" scoped></style>
